<template>
<div class="chapter">
<div class="inner_page">
<p class="epit"><a id="epigraph"><span class="txit"></span></a><a id="page_3">Did you ever read Five <span class="smallcaps">A.M.</span><span class="txit">? By that French writer, very famous French writer. In the fifties. He would wake at five in the morning, and that’s the whole book. Thinking is the thing that keeps him from going back to sleep. All at five o’clock in the morning.</span></a></p><a id="page_3">
<p class="epi"><span class="txit">I woke up. It was like clockwork. When I went to sleep I was like exhausted. I couldn’t think at all. At five o’clock in the morning it began to go through my head. And through the head is like a thread which holds together all the various thoughts and what is the outcome of the whole thing. And it goes on and on.</span></p>
<p class="epi"><span class="txit">So you have to tell the truth. You can’t do anything else. There’s no other way to go. You make the best deal you know how. And it didn’t even occur to me, even in that, that anybody was dying.</span></p>
</a><p class="epi-att"><a id="page_3"><span class="smallcaps">—DAVID GREENGLASS</span></a><a id="page_4"></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?240397bc